import { useState, useEffect, useCallback } from 'react';
import { Container, Content, Main, Footer } from './styled';
import { Modal, ContactNew, TransmissionList } from '../../components';
import {
    ProgressSteps,
    ContactsStep,
    ListsStep,
    MessageStep,
    SendStep
} from './components';
import { getFullClients } from '../../service/serviceChat/clientsService';
import { toast } from 'react-toastify';
import {
    getTransmission,
    sendTemplateTransmissao
} from '../../service/serviceChat/transmissionService';
import { useChat } from '../../contexts/chat';

export function ShootingMessage({ alowCreateList }) {

    const { handleMyChats } = useChat();

    const [lists, setLists] = useState([]);
    const [listsSelected, setListsSelected] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [contactsSelected, setContactsSelected] = useState([]);
    const [template, setTemplate] = useState({});
    const [searchInList, setSearchInList] = useState('');
    const [searchInContacts, setSearchInContacts] = useState('');
    const [next, setNext] = useState(0);
    const [render, setRender] = useState(0);
    const [destiny, setDestiny] = useState([]);
    const [checkbox1, setCheckbox1] = useState(false);
    const [loading, setLoading] = useState(false);
    const [displayedPeople, setDisplayedPeople] = useState(50);

    // Memoized API calls
    const searchList = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getTransmission();
            setLists(data);
        } catch (error) {
            toast.error('Erro ao carregar listas', { position: "top-center", theme: "colored" });
        } finally {
            setLoading(false);
        }
    }, []);

    const searchContacts = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getFullClients();
            setContacts(data);
        } catch (error) {
            toast.error('Erro ao carregar contatos', { position: "top-center", theme: "colored" });
        } finally {
            setLoading(false);
        }
    }, []);

    // Initial load - carrega dados apenas quando o componente abre
    useEffect(() => {
        const loadInitialData = async () => {
            // Carrega contatos e listas em paralelo na abertura do componente
            await Promise.all([
                searchContacts(),
                searchList()
            ]);
        };

        loadInitialData();
    }, [searchContacts, searchList]); // Dependência vazia - executa apenas uma vez na montagem

    // Handle step changes - apenas atualiza destiny no step 3
    useEffect(() => {
        if (next === 3) {
            setDestiny([...contactsSelected, ...listsSelected]);
        }
    }, [next, contactsSelected, listsSelected]);

    // Memoized functions
    const reset = useCallback(() => {
        setContactsSelected([]);
        setListsSelected([]);
        setTemplate({});
        setSearchInList('');
        setSearchInContacts('');
        setDestiny([]);
        setNext(0);
    }, []);

    const onSelectProgress = useCallback((goTo) => {
        if (goTo === 'next') {
            if (next < 3) setNext(next + 1);
            return;
        }
        if (next > 0) setNext(next - 1);
    }, [next]);

    const onFilterList = useCallback((obj) => {
        return obj?.nome?.toLowerCase()?.includes(searchInList?.toLowerCase());
    }, [searchInList]);

    const onFilterContacts = useCallback((obj) => {
        return obj?.name?.toLowerCase()?.includes(searchInContacts?.toLowerCase()) ||
            obj?.number_client?.toLowerCase()?.includes(searchInContacts?.toLowerCase());
    }, [searchInContacts]);
    // Selection functions
    const select = useCallback((item, from, setFrom, to, setTo) => {
        const newFrom = from.filter(fromItem => fromItem.id !== item.id);
        const newTo = [...to, item];
        setFrom(newFrom);
        setTo(newTo);
    }, []);

    const removeSelected = useCallback((item, from, setFrom, to, setTo) => {
        const newFrom = from.filter(fromItem => fromItem.id !== item.id);
        const newTo = [...to, item];
        setFrom(newFrom);
        setTo(newTo);
    }, []);




    // Optimized send function
    const onSend = useCallback(async () => {
        setLoading(true);

        try {
            // Validation
            if (destiny?.length <= 0) {
                toast.warn('Por favor, selecione um contato ou lista de contatos', {
                    position: "top-center",
                    theme: "colored"
                });
                return;
            }

            if (!template || (!template.id && !template?.template?.id)) {
                toast.warn('Por favor, selecione uma mensagem', {
                    position: "top-center",
                    theme: "colored"
                });
                return;
            }

            // Prepare data
            const IDcontactsSelected = contactsSelected.map(item => item.number_client);
            const IDlistsSelected = listsSelected.map(item => item.id);

            const data = {
                transmissao_id: IDlistsSelected,
                client_number: IDcontactsSelected,
                template_id: template.id || template?.template?.id,
                parametros: template?.parameters?.map(item => ({ param: item })),
                manter_atendimento_aberto: checkbox1 ? 'S' : 'N'
            };

            const response = await sendTemplateTransmissao(data);

            if (response?.status === 200) {
                toast.success('Mensagem Enviada!', {
                    position: "top-center",
                    theme: "colored"
                });

                if (checkbox1) {
                    handleMyChats();
                }
                reset();
            } else {
                response?.data?.message?.forEach(item => {
                    toast.error(`Erro ao enviar mensagem para: ${item.recipient}`, {
                        position: "top-center",
                        theme: "colored"
                    });
                });
            }
        } catch (error) {
            toast.error('Erro inesperado ao enviar mensagem', {
                position: "top-center",
                theme: "colored"
            });
        } finally {
            setLoading(false);
        }
    }, [destiny, template, contactsSelected, listsSelected, checkbox1, handleMyChats, reset]);

    // Handler functions for sub-components
    const handleSelectContact = useCallback((item) => {
        select(item, contacts, setContacts, contactsSelected, setContactsSelected);
    }, [select, contacts, contactsSelected]);

    const handleRemoveContact = useCallback((item) => {
        removeSelected(item, contactsSelected, setContactsSelected, contacts, setContacts);
    }, [removeSelected, contactsSelected, contacts]);

    const handleSelectList = useCallback((item) => {
        select(item, lists, setLists, listsSelected, setListsSelected);
    }, [select, lists, listsSelected]);

    const handleRemoveList = useCallback((item) => {
        removeSelected(item, listsSelected, setListsSelected, lists, setLists);
    }, [removeSelected, listsSelected, lists]);


    return (
        <>
            <Container disabled={loading ? 1 : 0}>
                <Content>
                    <ProgressSteps
                        currentStep={next}
                        onStepClick={setNext}
                    />
                    <Main>
                        {next === 0 && (
                            <ContactsStep
                                contacts={contacts}
                                contactsSelected={contactsSelected}
                                searchInContacts={searchInContacts}
                                setSearchInContacts={setSearchInContacts}
                                displayedPeople={displayedPeople}
                                setDisplayedPeople={setDisplayedPeople}
                                onSelectContact={handleSelectContact}
                                onRemoveContact={handleRemoveContact}
                                onNewContact={() => setRender(1)}
                                loading={loading}
                                onFilterContacts={onFilterContacts}
                            />
                        )}
                        {next === 1 && (
                            <ListsStep
                                lists={lists}
                                listsSelected={listsSelected}
                                searchInList={searchInList}
                                setSearchInList={setSearchInList}
                                onSelectList={handleSelectList}
                                onRemoveList={handleRemoveList}
                                onNewList={() => setRender(2)}
                                loading={loading}
                                onFilterList={onFilterList}
                                allowCreateList={alowCreateList}
                            />
                        )}
                        {next === 2 && (
                            <MessageStep
                                template={template}
                                onTemplateChange={setTemplate}
                            />
                        )}
                        {next === 3 && (
                            <SendStep
                                template={template}
                                destiny={destiny}
                                checkbox1={checkbox1}
                                setCheckbox1={setCheckbox1}
                                loading={loading}
                            />
                        )}
                    </Main>
                </Content>
                <Footer style={{ justifyContent: next <= 0 && 'end' }}>
                    {next > 0 && (
                        <button onClick={() => onSelectProgress('')}>
                            Anterior
                        </button>
                    )}
                    {next === 3 && (
                        <div className='alert--red'>
                            O envio das mensagens pode estar sujeito a cobranças
                        </div>
                    )}
                    {next < 3 ? (
                        <button onClick={() => onSelectProgress('next')}>
                            Próximo
                        </button>
                    ) : (
                        <button
                            className='send'
                            style={{ padding: !loading ? '1rem' : '0' }}
                            onClick={onSend}
                        >
                            {!loading ? (
                                <>Enviar</>
                            ) : (
                                <span className='loader' />
                            )}
                        </button>
                    )}
                </Footer>
            </Container>
            <Modal
                isOpen={render === 1 ? 1 : 0}
                close={() => {
                    searchContacts();
                    setRender(0)
                }}
            >
                {render === 1 &&
                    <ContactNew
                        onBack={() => {
                            setRender(0);
                        }}
                        onLoadContacts={() => searchContacts()}
                    />
                }
            </Modal>
            <Modal
                isOpen={render === 2 ? 1 : 0}
                close={() => {
                    searchList();
                    setRender(0)
                }}
            >
                {render === 2 &&
                    <TransmissionList
                        back={() => setRender(0)}
                        soucerData={lists}
                        alowCreateList={alowCreateList}
                    />
                }
            </Modal>
        </>
    );
}